@if (content) {
<icms-outlet [components]="content?.components"
             [allow]="allow"
             [allowOnly]="allowOnly"
             [disallow]="disallow"
             [options]="outletOptions"
             [name]="name"></icms-outlet>
}